/**
 * Maps a language code to the corresponding flag file name in icons-flag.svg sprite.
 * Most language codes match their flag code directly (es -> es, pt -> pt).
 * Only exceptions are handled explicitly.
 */
const FLAG_EXCEPTIONS: Record<string, string> = {
  en: 'gb',
  ca: 'es-ct',
};

export function getFlagFile(languageCode: string | undefined): string {
  const code = languageCode?.toLowerCase() ?? 'es';
  return FLAG_EXCEPTIONS[code] ?? code;
}

const SUPPORTED_LANGUAGES = new Set(['es', 'pt', 'en', 'ca']);

export function getFlagFileOrNull(cultureOrLanguageCode: string | null | undefined): string | null {
  if (!cultureOrLanguageCode) return null;
  const lang = cultureOrLanguageCode.toLowerCase().split('-')[0];
  if (!SUPPORTED_LANGUAGES.has(lang)) return null;
  return FLAG_EXCEPTIONS[lang] ?? lang;
}

const GROUP_NAME_FLAG_KEYWORDS: { keywords: string[]; code: string }[] = [
  { keywords: ['portugal'], code: 'pt' },
  { keywords: ['uk', 'united kingdom', 'britain'], code: 'gb' },
];

export function getGroupFlagCode(groupName: string | undefined): string {
  const name = (groupName ?? '').toLowerCase();
  for (const entry of GROUP_NAME_FLAG_KEYWORDS) {
    if (entry.keywords.some(k => name.includes(k))) return entry.code;
  }
  return 'es';
}
